module.exports = __webpack_public_path__ + "img/ac4.b4e78eb4.jpg";